export default "__VITE_ASSET__yy0nOyQS__"